<template>
  <article>
    <section>
      <label class="blue-grey-text text-darken-4"><strong>52 Week Price Range</strong></label>
    </section>
    <section>
      <div class="tick first">
        <span class="grey-text">${{ min }}</span>
      </div>
      <div class="block first"
          :class="{'indigo accent-2': selectedBlock === 1, 'grey lighten-3': selectedBlock !== 1}"
      />
      <div class="block"
          :class="{'indigo accent-2': selectedBlock === 2, 'grey lighten-3': selectedBlock !== 2}"
      />
      <div class="block"
          :class="{'indigo accent-2': selectedBlock === 3, 'grey lighten-3': selectedBlock !== 3}"
      />
      <div class="block"
          :class="{'indigo accent-2': selectedBlock === 4, 'grey lighten-3': selectedBlock !== 4}"
      />
      <div class="block last"
          :class="{'indigo accent-2': selectedBlock === 5, 'grey lighten-3': selectedBlock !== 5}"
      />
      <div class="tick last">
        <span class="grey-text">${{ max }}</span>
      </div>
    </section>
    <section>
      <div class="tick">
        <span class="indigo-text text-accent-2 strong" v-if="selectedBlock === 1">
          ${{ value }}
        </span>
      </div>
      <div class="tick">
        <span class="indigo-text text-accent-2 strong" v-if="selectedBlock === 2">
          ${{ value }}
        </span>
      </div>
      <div class="tick">
        <span class="indigo-text text-accent-2 strong" v-if="selectedBlock === 3">
          ${{ value }}
        </span>
      </div>
      <div class="tick">
        <span class="indigo-text text-accent-2 strong" v-if="selectedBlock === 4">
          ${{ value }}
        </span>
      </div>
      <div class="tick">
        <span class="indigo-text text-accent-2 strong" v-if="selectedBlock === 5">
          ${{ value }}
        </span>
      </div>
    </section>
  </article>
</template>

<script>
export default {
  name: 'RangePrice',
  components: {},
  props: {
    value: {
      type: Number,
      required: true,
    },
    min: {
      type: Number,
      required: true,
    },
    max: {
      type: Number,
      required: true,
    },
  },
  computed: {
    selectedBlock() {
      const range = this.max - this.min;
      const bucketSize = range / 5;
      const selected = (this.value - this.min) / bucketSize;
      const rounded = Number(selected.toFixed(0)) || 1;
      return rounded;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/main.scss';

.block {
  display: inline-block;
  height: 15px;
  width: 30px;
  border-left: 1px solid $tmf-black;
  border-top: 1px solid $tmf-black;
  border-bottom: 1px solid $tmf-black;
  &.first {
    border-radius: 5px 0px 0px 5px;
  }
  &.last {
    border-right: 1px solid $tmf-black;
    border-radius: 0px 5px 5px 0px;
  }
}

.tick {
  position: relative;
  display: inline-block;
  height: 10px;
  width: 30px;
  font-size: 0.75rem;
  bottom: 5px;
  &.first {
    right: 5px;
    direction: rtl;
  }
  &.last {
    left: 5px;
  }
}
</style>
